const ToggleSwitch = ({ value = "global", onChange }) => {
  return (
    <div className="flex items-center justify-start">
      <button
        type="button"
        onClick={() => onChange(value === "global" ? "artist" : "global")}
        className={`relative inline-flex h-10 w-28 rounded-full transition-all duration-300 ${
          value === "artist"
            ? "bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 shadow-lg"
            : "bg-gray-300"
        }`}
      >
        <span
          className={`absolute top-1 left-1 h-8 w-12 rounded-full bg-white shadow-md flex items-center justify-center text-xs font-semibold transition-transform duration-300 ${
            value === "artist" ? "translate-x-14" : "translate-x-0"
          }`}
        >
          {value === "artist" ? "Artist" : "Global"}
        </span>
      </button>
    </div>
  );
};

export default ToggleSwitch;